import React from 'react';
import PropTypes from 'prop-types';
import Modal from '$components/Modal';
import TextField from '$components/TextField';
import AssignmentSelector from '$components/AssignmentSelector';
import {
  AssessmentItem as AssessmentItemType,
  Assignment as AssignmentType,
  ViewAs,
} from '$variables/types';
import { STUDENT } from '$variables/constants';
import getAssignmentOptions from './utils/getAssignmentOptions';

import {
  Header,
  Content,
  Subtitle,
  SelectorContainer,
  Message,
  MessageLink,
} from './AssignmentMappingsViewModal.styled';

const AssignmentMappingsViewModal = ({
  open,
  onClose,
  assignments,
  assessmentItem: { title, mappedAssignments: mappings = [] },
  viewAs,
  spaceId,
}) => {
  const assignmentOptions = getAssignmentOptions({ assignments, mappings });
  const hasMappings = mappings && mappings.length > 0;

  const noMappingsMessage =
    viewAs === STUDENT ? (
      <Message>
        No assignments have yet been mapped to this assessment item.
      </Message>
    ) : (
      <Message>
        No assignments have yet been mapped to this assessment item. To fix
        this, click on an assessment item in the{' '}
        <MessageLink to={`/${spaceId}`}>Assignments page</MessageLink>.
      </Message>
    );

  return (
    <Modal headerText="Assessment item" open={open} handleClose={onClose}>
      <Header>
        <TextField
          variant="outlined"
          label="Assessment item title"
          defaultValue={title}
          disabled
          margin="dense"
          fullWidth
        />
      </Header>
      <Content>
        {!hasMappings && noMappingsMessage}
        {hasMappings && (
          <>
            <Subtitle>Composed of:</Subtitle>
            {mappings.map((assignment) => (
              <SelectorContainer key={assignment.id}>
                <AssignmentSelector
                  selectOptions={assignmentOptions}
                  selectedAssignment={assignment}
                  isMultiple={mappings.length > 1}
                  disabled
                />
              </SelectorContainer>
            ))}
          </>
        )}
      </Content>
    </Modal>
  );
};

AssignmentMappingsViewModal.propTypes = {
  spaceId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  assignments: PropTypes.arrayOf(AssignmentType).isRequired,
  assessmentItem: AssessmentItemType.isRequired,
  viewAs: ViewAs,
};

AssignmentMappingsViewModal.defaultProps = {
  viewAs: STUDENT,
};

export default AssignmentMappingsViewModal;
